import { CENTER_v1_1_1 } from './schemaDefaults/center';
import { FULL_WIDTH_v1_1_1 } from './schemaDefaults/fullWidth';
import { MONOGRAM_v1_1_1 } from './schemaDefaults/monogram';
import { NO_PHOTO_v1_1_1 } from './schemaDefaults/noPhoto';
import { PAGE_WIDTH_v1_1_1 } from './schemaDefaults/pageWidth';
import { PHOTO_ARCH_v1_1_1 } from './schemaDefaults/photoArch';
import { PHOTO_DUO_LEFT_v1_1_1 } from './schemaDefaults/photoDuoLeft';
import { PHOTO_DUO_RIGHT_v1_1_1 } from './schemaDefaults/photoDuoRight';
import { PHOTO_MARQUEE_v1_1_1 } from './schemaDefaults/photoMarquee';
import { PHOTO_BACKGROUND_v1_1_3 } from './schemaDefaults/photoBackground';
import { PHOTO_SLIDER_v1_1_1 } from './schemaDefaults/photoSlider';
import { PHOTO_TRIO_v1_1_1 } from './schemaDefaults/photoTrio';
import { PHOTO_TRIO_PAGE_WIDTH_v1_1_1 } from './schemaDefaults/photoTrioPageWidth';

export const PHOTO_PRESENTATION_LAYOUT_SCHEMA_URL_BY_WEBSITE_LAYOUT = {
  aloha: {
    center: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/center-v1_1_1.json',
      template: CENTER_v1_1_1,
    },
    photoSlider: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoSlider-v1_1_1.json',
      template: PHOTO_SLIDER_v1_1_1,
    },
  },
  brannan: {
    monogram: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/monogram-v1_1_1.json',
      template: MONOGRAM_v1_1_1,
    },
    center: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/center-v1_1_1.json',
      template: CENTER_v1_1_1,
    },
    fullWidth: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/fullWidth-v1_1_1.json',
      template: FULL_WIDTH_v1_1_1,
    },
    pageWidth: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/pageWidth-v1_1_1.json',
      template: PAGE_WIDTH_v1_1_1,
    },
    photoSlider: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoSlider-v1_1_1.json',
      template: PHOTO_SLIDER_v1_1_1,
    },
    photoTrio: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoTrio-v1_1_1.json',
      template: PHOTO_TRIO_v1_1_1,
    },
    photoTrioPageWidth: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoTrioPageWidth-v1_1_1.json',
      template: PHOTO_TRIO_PAGE_WIDTH_v1_1_1,
    },
    noPhoto: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/noPhoto-v1_1_1.json',
      template: NO_PHOTO_v1_1_1,
    },
    photoArch: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoArch-v1_1_1.json',
      template: PHOTO_ARCH_v1_1_1,
    },
    photoDuoLeft: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoDuoLeft-v1_1_1.json',
      template: PHOTO_DUO_LEFT_v1_1_1,
    },
    photoDuoRight: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoDuoRight-v1_1_1.json',
      template: PHOTO_DUO_RIGHT_v1_1_1,
    },
    photoMarquee: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoMarquee-v1_1_1.json',
      template: PHOTO_MARQUEE_v1_1_1,
    },
    photoBackground: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoBackground-v1_1_3.json',
      template: PHOTO_BACKGROUND_v1_1_3,
    },
  },
};
